export function syncContentGeneratorPoseThumbnails(
  scope,
  spicyEnabled = null
) {
  const $scope = scope?.jquery ? scope : $(scope);
  const isSpicy =
    spicyEnabled === null
      ? $scope.find('input[name="nsfw_chat"]').first().is(":checked")
      : Boolean(spicyEnabled);

  $scope
    .find(".content-generator-pose-options-single-item[data-image-sfw][data-image-spicy]")
    .each(function () {
      const $item = $(this);
      const imageUrl = $item.attr(
        isSpicy ? "data-image-spicy" : "data-image-sfw"
      );

      if (imageUrl) {
        $item.find(".pose-thumbnail").css("background-image", `url("${imageUrl}")`);
      }
    });
}
